/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/


import React from 'react';
// import ReactDOM from 'react-dom'
// import * as ReactDOM from 'react-dom/client';
import ReactDOM from 'react-dom';

import './LeftPanel.scss';
import Images from 'constants/Images';
import Texts from 'constants/Texts';
import Card from './Card.js';
import SystemConfiguration from 'settings/SystemConfiguration';
import $, { event } from "jquery";


class LeftPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {cards: "hello", selected: "hello", files: []};
    }


    componentDidMount() {
        var xmlhttp = new XMLHttpRequest();
        // NOTE: Local path
        // var url = "EvaVisualiser/data/eva.json";
        // NOTE: Remote path
        // var url = "data/eva.json";


        var url = process.env.PUBLIC_URL + "/data/eva.json";

        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                var myArr = JSON.parse(xmlhttp.responseText);
                // make this array globally available
                SystemConfiguration.mesh_data = myArr
                
                var cards = myArr.map(function(mesh_file, index){
                    SystemConfiguration.type_list.push(mesh_file["type"])
                    return <Card key={mesh_file["name"]} 
                                filename={mesh_file["name"]}
                                description={mesh_file["type"]}/>;
                })

                this.setState({cards: cards, selected: cards});
                const root = document.getElementById("leftpanel_content")

            }
        }.bind(this)
        xmlhttp.open("GET", url, true);
        xmlhttp.send();
    }



    render() {

        var panel_style = {
            width: window.innerWidth > 1200 ? window.innerWidth / 2 : window.innerWidth,
            visibility: window.innerWidth > 1200 ? "visible" : "hidden",
            height: window.innerWidth > 1200 ? window.innerHeight - 50 : window.innerHeight - 100,
          }

        var footer_style = {
            visibility: window.innerWidth > 1200 ? "visible" : "hidden",
            top: window.innerHeight - 100
            // height: window.innerWidth > 1200 ? 50 : 0,
        } 

        // console.log(SystemConfiguration.type_list)

        // Remove duplicates
        SystemConfiguration.type_list = SystemConfiguration.type_list.filter(function(item, pos) {
            return SystemConfiguration.type_list.indexOf(item) == pos;
        })
        const selectItems = []

        for (let i = 0; i < SystemConfiguration.type_list.length; i++) {
            const selectName = SystemConfiguration.type_list[i]
            selectItems.push(<option key={selectName} value={selectName}>{selectName}</option>)
        } 

        const handleChange = (event) => {
            if(event.target.value == "All") {
                this.setState({selected: this.state.cards});
                return
            }
            const selectedArr = this.state.cards.filter(objekt => objekt.props.description === event.target.value);
            this.setState({selected: selectedArr});
        }

        const handleSearch = (event) => {
            console.log(event.target.value)

            const selectedArr = this.state.cards.filter(objekt => objekt.props.filename.toLowerCase().includes(event.target.value.toLowerCase()));

            this.setState({selected: selectedArr});
        }



        return (
            <div id="leftpanel_main" style={panel_style}>
                <div id="leftpanel_body">
                    <div id="leftpanel_content">{this.state.selected}</div>
                </div>
                <div id="leftpanel_header">
                    <select name="cars" id="select_type" defaultValue="All" onChange={event => handleChange(event)}>
                        <option value="" disabled>Choose Type</option>
                        <option value="All" >All</option>
                        {selectItems}
                    </select>
                    <input id="searchbar" type="text" placeholder="Search..." onChange={event => handleSearch(event)}></input>
                </div>
                <div id="leftpanel_footer" style={footer_style}>
                    <div id="leftpanel_lab">Part of the Immersive Media Lab Application Suite</div>
                    <div id="leftpanel_copyright">Copyright &copy; 2024 Herbert M. Potechius. All rights reserved.</div>
                </div>
            </div>
        );
    }
}

export default LeftPanel;